const localization = {
  dashboardPage: {
    executiveHeading: "Executive Summary",
    executiveText: "Overall User / System and Revenue Analysis",
    totalRegistered: "Total registered companies",
    totalRegisteredHead: "Total Registered",
    totalActive: "Total active companies",
    totalActiveHead: "Total Active",
    totalPaid: "Total Paid (Inc. Credit)",
    totalPaidHead: "Paid Bills",
    salesOrderTab: "Sales Order",
    quotationsTab: "Quotations",
    rfqTab: "Manage RFQ\'s"
  },
  clientsListing: {
    heading: "Clients",
    allClientsTab: "All Clients",
    allClientsTabSub: "All Sub Clients",
    clientsListingLink1: "View Client",
    clientsListingLink2: "Dashboard",
    pendingInvitations: "Pending Invitations",
    pendingInvitationsSub: "Pending Invitations",
    signupButton: "Signup Link",
    inviteButton: "Invite New Client",
    addNewButton: "Add New Client",
    inviteButtonSub: "Invite New Sub User",
    addNewButtonSub: "Add New Sub User",
  },
  clientsAgreementsListing: {
    heading: "Client Agreements",
    allAgreementsTab: "Client Agreements",
    allAgreementsTabSub: "Client Agreements",
    agreementsListingLink1: "Edit Agreement",
    agreementsListingLink2: "Delete Agreement",
    archivedTab: "Archived",
    archivedTabSub: "Archived",
    addNewButton: "Add New Agreement",
  },
  clientsRoles: {
    heading: "Client Menu",
    mainRolesTab: "Main Menu",
    mainRolesSub: "Client Menu",
    mainRoleLink: "Edit Menu Item",
    subRoleTab: "Sub Menu",
    subRoleTabSub: "Client Sub Menu",
    subRoleLink: "Edit Sub Menu",
    addNewButton: "Add New Menu",
    addNewButtonLink1: "New Main Menu",
    addNewButtonLink2: "New Sub Menu",
  },
  productListing: {
    heading: "Products & Services",
    addNewButton: "Add New",
    selectServiceType: "Select Service Type",
    selectServiceTypePlaceHolder: "Select a service type to view its services.",
    selectServiceTypeEmpty: "Service type not found",
    listingLink1: "Edit Product",
    listingLink2: "View Product",
    detailsPopupHead: "Product Details",
    detailsPopupOtherServicesHead: "Other Service Rates",
    detailsPopupCancellationHead: "Cancellation Fee",
    detailsPopupCancellationText: "Cancellation Fee",
    detailsPopupDatesHead: "Add / Update Dates",
    detailsPopupDatesAdd: "Date Added",
    detailsPopupDatesUpdate: "Date Updated",
    detailsPopupDescriptionHead: "Description",
    detailsPopupSummary: "Summary",
    detailsPopupMiscHead: "Miscellaneous Rates",
    detailsPopupMarketingHead: "Marketing Link",
    detailsPopupMarketingText: "Marketing Link",
    detailsPopupMarketingLinkOpen: "Click to open link",
    detailsPopupMarketingLinkView: "View PDF",
    detailsPopupIntegration: "3rd Party Integration"
  },
  productTypeListing: {
    heading: "Products & Services Types",
    addNewButton: "Add New",
    listingLink1: "Edit",
    listingLink2: "Default Value",
    listingLink3: "Unarchive",
  },
  //Partner Listing
  agentsListing: {
    heading: "Partners",
    signupButton: "Partner Signup Link",
    inviteButton: "Invite New Partner",
    addNewButton: "Add New Partner",
    allCPTab: "Partners",
    listingLink1: "Edit Partner",
    listingLink2: "Agreements",
    listingLink3: "Commissions",
    listingLink4: "Sub Partners",
    listingLink5: "Assign Menu",
    listingLink6: "Dashboard",
    invitationTab: "Pending Invitations",
    listingLink7: "Login Details",
  },
  agentAgreementsListing: {
    heading: "Partner Agreements",
    allAgreementsTab: "Partner Agreements",
    allAgreementsTabSub: "Partner Agreements",
    agreementsListingLink1: "Edit Agreement",
    agreementsListingLink2: "Delete Agreement",
    archivedTab: "Archived",
    archivedTabSub: "Archived",
    addNewButton: "Add New Agreement",
  },
  //Partner Roles
  agentRoles: {
    heading: "Partner Menu",
    mainRolesTab: "Menu",
    mainRolesSub: "Partner Menu",
    mainRoleLink: "Edit Menu",
    subRoleTab: "Sub Menu",
    subRoleTabSub: "Partner Sub Menu",
    subRoleLink: "Edit Sub Menu",
    addNewButton: "Add New Menu",
    addNewButtonLink1: "New Main Menu",
    addNewButtonLink2: "New Sub Menu",
  },
  quotationListing: {
    heading: "Quotations",
  },
  ordersListing: {
    heading: "Sale Orders",
    addNewButton: "Add New",
    chooseClient: "Choose Client",
    chooseClientPlaceholder: "Select a client to view his order.",
    chooseClientEmpty: "Clients not available"
  },
  orderAddUpdate: {
    heading: "Sale Orders",
    subHeading: "Add New Sale Order",
    clientDetailHead: "ORDER FOR",
    orderDetailHead: "ORDER",
    chooseClientPlaceholder: "Select a client to view his order.",
    chooseClientEmpty: "Clients not available"
  },
  specificPortals: {
    agentLabel: "Partner",
    agentsLabel: "Partners",
    agentText: "partner",
    agentsText: "partners",
    sharelinkLabel: "Affiliate Link",
    sharelinksLabel: "Affiliate Links",
    sharelinktext: "affiliate link",
    sharelinkstext: "affiliate links",
  },
  // Add more pages as needed
};

export default localization;